import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDriverEquipStatusCodeQuickInfo extends Layout {
    panelQuickInfo: Panel;
    sourceEquipstatuscode: DataSource;
    textboxCode: Textbox;
    textboxDescr: Textbox;
}
